import { render, staticRenderFns } from "./StageModalNext.vue?vue&type=template&id=2741453d&scoped=true"
import script from "./StageModalNext.vue?vue&type=script&lang=js"
export * from "./StageModalNext.vue?vue&type=script&lang=js"
import style0 from "./StageModalNext.vue?vue&type=style&index=0&id=2741453d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741453d",
  null
  
)

export default component.exports